import apiClient from "./apiClient";

const baseURL = "email";
export default {
  verify: data => apiClient.get(`${baseURL}/verify-email?token=${data.token}`),
  resend: data => apiClient.post(`${baseURL}/resend-verification`, data)
};
